import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface QrCodeProps {
  value: string;
  size?: number;
}

/** ແປງຂໍ້ຄວາມ EMVCo ເປັນຮູບ QR (SVG ເພື່ອໃຫ້ຄົມທຸກຂະໜາດໜ້າຈໍ) */
export function QrCode({ value, size = 260 }: QrCodeProps) {
  const [svg, setSvg] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;

    QRCode.toString(value, {
      type: 'svg',
      errorCorrectionLevel: 'M',
      margin: 1,
      width: size,
    })
      .then((markup) => {
        if (active) {
          setSvg(markup);
          setFailed(false);
        }
      })
      .catch(() => {
        if (active) setFailed(true);
      });

    return () => {
      active = false;
    };
  }, [value, size]);

  if (failed) {
    return <p className="alert">ສ້າງຮູບ QR ບໍ່ໄດ້</p>;
  }

  return (
    <div
      className="qr"
      style={{ width: size, height: size }}
      role="img"
      aria-label="QR ສຳລັບໂອນເງິນ"
      // markup ມາຈາກ qrcode library ໃນ browser ເອງ ບໍ່ແມ່ນ input ຂອງຜູ້ໃຊ້
      dangerouslySetInnerHTML={svg ? { __html: svg } : undefined}
    />
  );
}
